import {Deserializable} from "./deserializable.model";

export class ppsDistrHubActionList {

public action_list_id?: number;
public action_list_name?:string;
public action_list_description?:string;
public is_active?:string;
public action_day_saved?: string;

public updated_by?: number;
public created_date?: string;
public updated_date?: number;
public created_by?: number;

public brand_id?: number;
public user_id?: number;
public job_type_id?: number;
public action_list_type_id?: number;
public action_list_type_name?: number;


public search_results_meta?: any;
/*
action_list_id
action_list_name
action_list_description
is_active
action_day_saved
updated_by
created_date
updated_date
created_by
brand_id
user_id
job_type_id
search_results_meta
action_list_type_id
*/


  // ? what does this really do? (no encoding or deserialisation required...)
  deserialize(input: any): ppsDistrHubActionList {
    Object.assign(this, input);

    return this;
  }


}
